import type { Routes } from "@angular/router";

/**
 * Series feature routes
 * Nested under /series with children for list, new, and manage
 * Note: series-manage now handles both editing and dash management via tabs
 */
export const seriesRoutes: Routes = [
	{
		path: "",
		loadComponent: () =>
			import("../series-list/series-list.component").then(
				(m) => m.SeriesListComponent,
			),
	},
	{
		path: "new",
		loadComponent: () =>
			import("../series-manage/series-manage.component").then(
				(m) => m.SeriesManageComponent,
			),
	},
	{
		path: ":id/edit",
		loadComponent: () =>
			import("../series-manage/series-manage.component").then(
				(m) => m.SeriesManageComponent,
			),
	},
	{
		path: ":id/manage",
		loadComponent: () =>
			import("../series-manage/series-manage.component").then(
				(m) => m.SeriesManageComponent,
			),
	},
];
